module.exports = __webpack_public_path__ + "img/device-secure.bf62397c.jpeg";